import React from 'react';
import {useTheme} from 'styled-components/native';

import {PaymentItemDTO} from '../../../../dtos/PaymentItemDTO';

import {Badge} from '../../../Interface/Badges/Badge';

import {
  Container,
  Infos,
  InfoContainer,
  Title,
  Date,
  Values,
  Value,
  Button,
  PaymentIconContainer,
  PaymentIcon,
} from './styles';

interface Props {
  data: PaymentItemDTO;
}

export function PaymentItem({data}: Props) {
  const theme = useTheme();

  return (
    <Container>
      <Button>
        <Infos>
          <PaymentIconContainer
            bgColor={data.paid ? theme.colors.primary : theme.colors.red}>
            <PaymentIcon
              name={
                data.paymentMethod === 'PIX'
                  ? 'pix'
                  : data.paymentMethod === 'CCT'
                  ? 'credit-card'
                  : 'attach-money'
              }
            />
          </PaymentIconContainer>
          <InfoContainer>
            <Title>
              {data.paymentMethod === 'PIX'
                ? 'PIX'
                : data.paymentMethod === 'CCT'
                ? 'Cartão de crédito'
                : 'Pagamento'}
            </Title>
            <Date>
              {data.created_at.date} às {data.created_at.time}
            </Date>
          </InfoContainer>
        </Infos>
        <Values>
          <Badge
            text={data.paid ? 'Pago' : 'Não pago'}
            containerStyle={{
              backgroundColor: data.paid
                ? theme.colors.primary
                : theme.colors.red,
              borderWidth: 0,
            }}
            textStyle={{
              color: data.paid ? theme.colors.shape : theme.colors.shape,
            }}
          />

          <Value
            style={{
              color:
                data.paid === true ? theme.colors.primary : theme.colors.red,
            }}>
            {data.value ? data.value : 'Não definido'}
          </Value>
        </Values>
      </Button>
    </Container>
  );
}
